<template>
  <div
    class="favorite-item"
    @mouseenter="mouseHover = true"
    @mouseleave="mouseHover = false"
  >
    <div class="item-wrapper">
      <router-link class="link truncate" :to="'/article/' + article.slug">{{
        article.title
      }}</router-link>
      <transition
        :duration="150"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <i
          v-if="(!isMobile && mouseHover) || (isMobile && toggleRemove)"
          class="material-icons"
          @click="removeFavorite"
        >
          delete
        </i>
      </transition>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class FavoriteItem extends Vue {
  @Prop() article;
  @Prop() toggleRemove;

  mouseHover = false;

  get isMobile() {
    return this.$store.state.isMobile;
  }

  removeFavorite() {
    this.$store.commit("removeFavorite", this.article);
  }
}
</script>

<style scoped lang="scss">
.favorite-item {
  // max-width: 200px;

  .item-wrapper {
    align-items: center;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    padding: 0 0.3em;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }

  .link {
    color: black;
    font-size: 1rem;
  }

  i {
    font-size: 1.2rem;
    cursor: pointer;
    &:hover {
      color: grey;
    }
  }

  // Materialize:s own truncate takes care of this.
  // .truncate-str {
  //   max-width: 120px;
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
}
</style>
